<template>
  <div class="MobileSort">
    <div class="SearchFilter-facetParent">
      <label
        for="sort-select"
        class="MobileSort-label SearchFilter-title"
      >
        Sort By:
      </label>
      <div class="select">
        <select
          id="sort-select"
          v-model="sortQuery"
          class="MobileSort-select"
        >
          <option
            v-for="(field, index) in config.fields"
            :key="index"
            :value="field.value"
          >
            {{ field.title }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    sortFields: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      ui: {},
      config: {
        fields: [
          {
            title: 'Company Name A-Z',
            value: 'company-asc',
          },
          {
            title: 'Company Name Z-A',
            value: 'company-desc',
          },
        ],
      },
      query: {},
    };
  },

  computed: {
    sortQuery: {
      get() {
        if (!this.$store.state.search.query.od) {
          const searchScope = this.$store.state.search.query.show;
          return this.$store.state.search.defaultSortOrders[searchScope];
        }
        return this.$store.state.search.query.od;
      },
      set(value) {
        const sortingUrls = this.getSortingUrls;
        this.updateSearchUrl(sortingUrls[value]);
        this.updateQuerySort({ sortParams: value });
      },
    },
    ...mapGetters('search', {
      getSortingUrls: 'getSortingUrls',
    }),
  },

  mounted() {
    this.config.fields.unshift(...this.sortFields);
  },

  methods: {
    ...mapMutations('search', {
      updateQuerySort: 'updateQuerySort',
      updateSearchUrl: 'updateSearchUrl',
    }),
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../../scss/abstracts/abstracts";
  .MobileSort-label {
    font-size: 18px;
    margin-bottom: 1em;
    font-weight: $font-weight-heavy;
    display: block;
    width: 100%;
    color: #000;
  }
  .select{
    width: 100%;
  }
  .MobileSort-select {
    width: 100%;
    margin: 0;
  }
</style>
